module.exports = __webpack_public_path__ + "img/slide-logo.fce32233.png";